import { defineRecipe } from '@chakra-ui/react';

export const buttonRecipe = defineRecipe({
    base: {
        borderRadius: '0',
        borderColor: 'transparent',
        borderWidth: '2px',
        transition: '0.25s',
        _hover: {
            opacity: '0.8',
        },
        _active: {
            transform: 'scale(0.95)',
        },
    },
    variants: {
        variant: {
            outline: {},
            solid: {},
        },
        size: {
            sm: {},
            md: {
                fontSize: '1.25rem',
                padding: '1.5rem',
            },
            lg: {
                fontSize: '2rem',
                fontWeight: 'bold',
                padding: '1rem',
            },
        },
        colorScheme: {
            primary: {
                background: '#000000',

                _hover: {
                    background: '#000000',
                },
            },
            accent: {
                background: '#E74C3C',
                color: 'white',

                _hover: {
                    background: '#E74C3C',
                },
            },
            transparent: {
                background: 'transparent',

                _hover: {
                    background: 'transparent',
                },
            },
        },
    },
});
